import { tv } from 'tailwind-variants'

export const floatingButtonVariants = tv({
  slots: {
    button: 'absolute right-5 w-10 bottom-5 bg-primary-medium rounded-mili p-mili',
    icon: 'flex text-kilo text-white'
  },
  variants: {
    show: {
      true: {
        button: 'visible'
      },
      false: {
        button: 'invisible'
      }
    }
  }
})
